// src/pages/legal/Terms.jsx  或 src/pages/Terms.jsx
import React from "react";
import "../styles/Auth.css";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";
import AuthNav from "../components/AuthNav";

export default function Terms() {
  return (
    <div className="auth-background">
      <AuthNav />

      <motion.div
        className="auth-page-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.35 }}
      >
        <div className="logo-container">
          <img src={logo} alt="Riceroma Logo" className="auth-logo" />
        </div>

        <div
          className="card"
          style={{
            maxWidth: "760px",
            margin: "0 auto 8px",
            padding: "28px 24px",
          }}
        >
          <h2
            style={{
              color: "#d77b00",
              fontSize: "22px",
              marginBottom: "16px",
              letterSpacing: "0.5px",
              textAlign: "center",
            }}
          >
            Terms of Use / 使用条款
          </h2>

          {/* 英文部分 */}
          <section
            style={{
              marginBottom: "18px",
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: "14px",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "8px",
                color: "#333",
              }}
            >
              1. Membership service
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              Riceroma membership is a personal, non-transferable service. Each
              member account is tied to a single individual and may be checked
              in-store using a QR code or ID.
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              2. Payments & renewal
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              Membership fees are charged through Stripe. By subscribing, you
              agree to the billing terms shown at checkout. Some plans may
              renew automatically unless cancelled before the next billing
              date.
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              3. Changes to the service
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              We may adjust menu items, prices or membership benefits from time
              to time. Any material changes to terms will be communicated via
              email or on this page.
            </p>
          </section>

          {/* 中文部分 */}
          <section>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "8px",
                color: "#333",
              }}
            >
              1. 会员服务
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              饭美丽会员仅限本人使用，不可转让。每个账号只对应一位会员，门店有权通过二维码或其他方式核验身份。
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              2. 付款与续费
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              会员费用通过 Stripe 代收。订阅时即视为同意结账页面展示的价格与续费规则。
              如为自动续费方案，请在下一计费日之前取消，以避免系统自动扣款。
            </p>

            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                margin: "12px 0 8px",
                color: "#333",
              }}
            >
              3. 服务变更
            </h3>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#444" }}>
              我们可能不定期调整菜单、价格或会员权益。如有重要变更，我们会通过网站公告或邮件进行说明。
            </p>

            <p
              style={{
                fontSize: 13,
                lineHeight: 1.7,
                color: "#777",
                marginTop: "14px",
              }}
            >
              使用本网站与会员服务，即表示你同意以上条款。如有疑问，请通过 About / Contact
              页面中的联系方式与我们沟通。
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
}